import { useContext } from "react";
import { CentralPanelProps } from "./types/centralPanelProps";
import ViewContext from "../../../contexts/viewContext";
import DataBaseView from "../../centralView/dataBaseView/dataBaseView";
import TaskListView from "../../centralView/taskListView/taskListView";
import HomeView from "../../centralView/homeView/homeView";
import KrFormView from "../../centralView/krFormView/krFormView";
import PoFormView from "../../centralView/poFormView/poFormView";
import DictionariesView from "../../centralView/dictionariesView/dictionariesView";
import AdministrationView from "../../centralView/administrationView/administrationView";
import CommunicationView from "../../centralView/communicationView/communicationView";
import CollectiveEditionView from "../../centralView/collectiveEditionView/collectiveEditionView";

const CentralPanel = (props: CentralPanelProps) => {
    const { viewType, viewTypes, viewData } = useContext(ViewContext);

    const renderView = (viewType: number) => {
        switch (viewType) {
            case viewTypes.Home:
                return (<HomeView data={viewData} />)
            case viewTypes.TaskList:
                return (<TaskListView />)
            case viewTypes.DataBase:
                return (<DataBaseView />)
            case viewTypes.Communication:
                return (<CommunicationView />)
            case viewTypes.Dictionaries:
                return (<DictionariesView />)
            case viewTypes.Administration:
                return (<AdministrationView />)
            case viewTypes.KRForm:
                return (<KrFormView data={viewData} />)
            case viewTypes.POForm:
                return (<PoFormView data={viewData} />)
            case viewTypes.CollectiveEditForm:
                return (<CollectiveEditionView rows={viewData} local={false} />)
            case viewTypes.CollectiveEditFormLocal:
                return (<CollectiveEditionView rows={viewData} local={true} />)
            default:
                return (<div>default view:</div>)
        }
    }

    return (<>{renderView(viewType)}</>);
}

export default CentralPanel;